export default __webpack_public_path__ + "static/media/request_invite.e28b6ce4.png";